// extracted by mini-css-extract-plugin
export default {"fullWidth":"Qp-z","image":"Rp-z","lazyLoadPicture":"Sp-z","lazyLoadSpinner":"Tp-z","lazyLoadSpin":"Up-z","lazyLoadImage":"Vp-z","hasStyledAspectRatio":"Wp-z"};